const STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-900 border-amber-300",
  assigned: "bg-sky-100 text-sky-900 border-sky-300",
  in_progress: "bg-indigo-100 text-indigo-900 border-indigo-300",
  completed: "bg-emerald-100 text-emerald-900 border-emerald-300",
  cancelled: "bg-slate-100 text-slate-600 border-slate-300",
  paid: "bg-emerald-100 text-emerald-900 border-emerald-300",
  unpaid: "bg-amber-100 text-amber-900 border-amber-300",
  new: "bg-sky-100 text-sky-900 border-sky-300",
};

const LABELS = {
  in_progress: "In progress",
};

export default function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
  const label = LABELS[status] || status?.replace(/_/g, " ") || "—";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] border ${cls} rounded-sm`}
    >
      {label}
    </span>
  );
}
